import { env } from '@/env'
import { api } from '@/services/fintalk/api'

export interface Dashboard {
  dashboard_id: string
  name: string
  bot_id: string
  active: boolean
  external_dashboard_id: string
  apply_bot_filter: boolean
  created_at: string
  updated_at: string
}

export interface ListDashboardsResponse {
  dashboards: Dashboard[]
}

export async function listDashboards(botId: string): Promise<Dashboard[]> {
  const resp = await api.get<ListDashboardsResponse>(
    env.VITE_FINTALK_BACKOFFICE_URL,
    `/bot/${botId}/dashboards`,
  )
  return resp.body.dashboards
}
